/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import successIcon from '../../../assets/icons/success.svg';
import errorIcon from '../../../assets/icons/error.svg';
import './styles.sass';

interface Params {
    password: string,
    email: string,
    isPasswordValidated: (check: boolean) => void,
}

export const PasswordRequirements = ({ password, email, isPasswordValidated }: Params) => {
    const [isEgualEmailCheck, setIsEgualEmail] = useState(false)
    const [sizeCheck, setSizeCheck] = useState(false)
    const [numberCheck, setNumberCheck] = useState(false)
    const [upperCaseCheck, setUpperCase] = useState(false)
    const [lowerCaseCheck, setLowerCase] = useState(false)
    const [specialCharacterCheck, setSpecialCharacter] = useState(false)
    
    useEffect(() => {
        const isEgualEmailCheck = password && email ? password.toLocaleLowerCase() !== email.toLocaleLowerCase() : false;
        const sizeCheck = /^.{8,50}$/.test(password);
        const numberCheck = /^.*([0-9])+.*$/.test(password);
        const upperCaseCheck = /^.*([A-Z])+.*$/.test(password);
        const lowerCaseCheck = /^.*([a-z])+.*$/.test(password);
        const specialCharacterCheck = /^.*([!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])+.*$/.test(password);
        
        setIsEgualEmail(isEgualEmailCheck);            
        setSizeCheck(sizeCheck);
        setNumberCheck(numberCheck);
        setUpperCase(upperCaseCheck);
        setLowerCase(lowerCaseCheck);
        setSpecialCharacter(specialCharacterCheck);

        isPasswordValidated(
            isEgualEmailCheck &&
            sizeCheck &&
            numberCheck &&
            upperCaseCheck &&
            lowerCaseCheck &&
            specialCharacterCheck
        );

    }, [password, email])

    return (
        <div className='password-requirements'>
            <b>Requisitos de senha</b>
            <p><img className='icon' src={isEgualEmailCheck ? successIcon : errorIcon} alt={isEgualEmailCheck ? 'check-icon' : 'not-check-icon'} /> A senha não pode ser igual ao login</p>
            <p><img className='icon' src={sizeCheck ? successIcon : errorIcon} alt={sizeCheck ? 'check-icon' : 'not-check-icon'} /> O tamanho da senha deve ser de 8 a 50 caracteres</p>
            <p><img className='icon' src={numberCheck ? successIcon : errorIcon} alt={numberCheck ? 'check-icon' : 'not-check-icon'} /> É necessario ter pelo menos um número</p>
            <p><img className='icon' src={upperCaseCheck ? successIcon : errorIcon} alt={upperCaseCheck ? 'check-icon' : 'not-check-icon'} /> É necessário pelo menos uma letra maiúscula</p>
            <p><img className='icon' src={lowerCaseCheck ? successIcon : errorIcon} alt={lowerCaseCheck ? 'check-icon' : 'not-check-icon'} /> É necessário pelo menos uma letra minúscula</p>
            <p><img className='icon' src={specialCharacterCheck ? successIcon : errorIcon} alt={specialCharacterCheck ? 'check-icon' : 'not-check-icon'} /> É necessário pelo menos um caractere especial</p>
        </div>
    )
}
